'use strict'

const { getPmMenuPosition } = require('../../../functions/getPmMenuPosition.js')
const { proseMirrorYjsPlugins } = require('../../../functions/proseMirrorYjsPlugins')

class RundownEditCtrl {
    constructor (Contact, $http, $mdDialog, masterStationInfo, itemModelTypes, $scope, $state, widgets, yConnection, yDraftConnections, $rootScope, $transitions) {
        this.Contact = Contact
        this.$http = $http
        this.$mdDialog = $mdDialog
        this.itemModelTypes = itemModelTypes
        this.$scope = $scope
        this.$state = $state
        this.widgets = widgets
        this.yConnection = yConnection
        this.yDraftConnections = yDraftConnections
        this.$rootScope = $rootScope
        this.$transitions = $transitions

        this.isMasterStation = masterStationInfo.isMasterStation
        this.readOnly = this.readOnly || !this.isMasterStation
        this.customFields = {}
        this.in_block = true //@todo fix this after fixing drafts
        this.pmMenuPos = 'bottom'

        // this.contactObserver = this.contactOnEvent.bind(this);
        this.updateModelTypeFields = _.debounce(this.updateModelTypeFields.bind(this), 25)

        this.checkForRelatedItems = {}

        $scope.timezone = window.CONFIG.timezone
        $scope.$on('item_contact_updated', this.contactUpdate.bind(this))

        const contentScrollContainerWatch = $scope.$watch(
            () => _.get(document.querySelector('.rundown-edit .rte-scroll'), 'parentElement.parentElement'),
            contentScrollContainer => {
                if (contentScrollContainer != null) {
                    contentScrollContainerWatch()

                    setTimeout(() => {
                        this.contentScrollContainer = contentScrollContainer
                        this.pmComponent = contentScrollContainer.querySelector('pbx-prosemirror')
                        this.calculatePmMenuPosition()

                        const onScroll = _.debounce(this.calculatePmMenuPosition.bind(this), 100, { maxWait: 2000 })
                        contentScrollContainer.addEventListener('scroll', onScroll)

                        $scope.$on('$destroy', () => {
                            contentScrollContainer.removeEventListener('scroll', onScroll)
                        })
                    })
                }
            }
        )

        for (let item in itemModelTypes) {
            if (itemModelTypes.hasOwnProperty(item)) {
                this.customFields[itemModelTypes[item].id] = itemModelTypes[item].fields
            }
        }

        this.getItemsForType(this.$state.params.type)
            .then(items => {
                try {
                    if ($state.params.itemId && items !== null) {
                        const id = parseInt($state.params.itemId)
                        this.pollCheckIfItemHasNotBeenDeleted(items, id)
                        let yItem = this.getItemById(items.toArray(), id)
                        if (yItem) {
                            this.yItem = yItem
                            this.initView()
                            return
                        }
                    }
                } catch (err) {
                    console.error(err)
                }

                // Go back if there is no item
                this.$state.go('^')
            })

        let unRegSaveListener = this.$transitions.onStart({}, (transition) => {
            let toState = transition.to()
            let toParams = transition.params()

            if (toState.name.indexOf('rundown.edit') < 0 && !this.dontCheckState) {
                transition.abort()
                this.widgets.saveWidgetsForTypeId('item-' + this.$state.params.itemId).then(() => {
                    unRegSaveListener()
                    this.$state.go(toState, toParams)
                })
            }
        })

        this.getItemsUrl = function () {
            if (!this.isMasterStation) return
            if (this.yItem.get('block_id')) {
                let id = this.yItem.get('id')
                let title = encodeURIComponent(this.yItem.get('title').toString().replace(/\//g, ' '))
                if (title.length > 2) {
                    if (title) {
                        let itemId
                        if (id) {
                            itemId = id
                        } else {
                            itemId = 0
                        }
                        return '/items/unique_item/' + itemId + '/' + title
                    }
                }
            }
        }.bind(this)

        this.checkRelatedItems = () => {
            this.checkForRelatedItems.update()
        }
    }

    pollCheckIfItemHasNotBeenDeleted (yItems, id) {
        let alreadyBeenCalled = false
        const observe = () => {
            const yItem = this.getItemById(yItems.toArray(), id)
            if (yItem == null && !alreadyBeenCalled) {
                alreadyBeenCalled = true
                this.goBackAction()
            }
        }

        yItems.observe(observe)
        this.$scope.$on('$destroy', () => {
            yItems.unobserve(observe)
        })
    }

    calculatePmMenuPosition () {
        this.$scope.$applyAsync(() => {
            this.pmMenuPos = getPmMenuPosition(this.pmComponent, this.contentScrollContainer)
        })
    }

    onContactSelect () {
        this.$scope.searchText = ''
        this.contactAddToItem(this.selectedContact)
        this.contactBlur()
    }

    getItemsForType (type) {
        switch (type) {

            case('block'):
                return this.getYConnection(parseInt(this.$state.params.blockId))
                    .then(conn => new Promise(resolve => {
                        const interval = setInterval(() => {
                            const yItems = conn.getMap('block').get('items')

                            if (yItems) {
                                clearInterval(interval)
                                resolve(yItems)
                            }

                        }, 100)
                    }))

            case('personal'):
            case('program'):
            case('station'):
                return this.getYDraftConnection(type)
                    .then(conn => new Promise(resolve => {
                        const interval = setInterval(() => {
                            const yItems = conn.getArray('items')

                            if (yItems instanceof Y.Array) {
                                clearInterval(interval)
                                resolve(yItems)
                            }

                        }, 100)
                    }))

            default:
                return Promise.resolve(null)

        }
    }

    getYConnection (blockId) {
        return new Promise((resolve) => {
            let connection = this.yConnection.getConnection(blockId)
            if (!connection) {
                this.yConnection.createConnection(blockId)
                    .then(connection => resolve(connection))
                return
            }
            // connection.connector.whenSynced(() => {
            resolve(connection)
            // });
        })
    }

    getYDraftConnection (type) {
        return new Promise((resolve) => {
            let connection = this.yDraftConnections[type]
            if (!connection) {
                resolve(null)
                return
            }
            // connection.connector.whenSynced(() => {
            resolve(connection)
            // });
        })
    }

    initView () {
        this.loaded = true

        const unReg = this.$scope.$watch(() => {
            return this.yItem.get('details')
        }, (yDetails) => {
            if (typeof yDetails !== 'undefined') {
                unReg()

                this.initProseMirror()
                setTimeout(() => {
                    this.calculatePmMenuPosition()
                }, 1000)
            }
        })
    }

    initProseMirror () {
        this.$scope.detailsPlugins = [
            ...proseMirrorYjsPlugins(this.yItem, undefined, () => !this.readOnly)
        ]
    }

    getRoomName () {
        switch (this.$state.params.type) {
            case 'block':
                return 'rundown.block.' + window.CONFIG.station_id + '.' + this.$state.params.blockId
            case 'personal':
                return 'rundown.personal.' + window.CONFIG.station_id + '.' + this.yItem.get('personal_id')
            case 'program':
                return 'rundown.program.' + window.CONFIG.station_id + '.' + this.yItem.get('program_id')
            case 'station':
                return 'rundown.station.' + window.CONFIG.station_id + '.' + this.yItem.get('station_id')
        }
    }

    contactOnEvent (event) {
        if (event.type === 'add' || event.type === 'update') {
            this.contacts[event.name] = event.value
        } else if (event.type === 'delete') {
            delete this.contacts[event.name]
        }
    }

    getItemById (yItems, itemId) {
        for (let i = 0; i < yItems.length; i++) {
            if (yItems[i].get('id') === itemId) {
                return yItems[i]
            }
        }

        return null
    }

    updateModelTypeFields (modelTypeId) {
        const modelType = this.itemModelTypes.find(modelType => (
            `${modelType.id}` === `${modelTypeId}`
        ))

        for (let item in modelType.fields) {
            if (modelType.fields.hasOwnProperty(item)) {
                let fieldValues = this.yItem.get('field_values')
                const fieldName = modelType.fields[item].name
                if (!fieldValues.get(fieldName)) {
                    fieldValues.set(fieldName, new Y.Text)
                }
            }
        }

        this.$scope.$apply()
    }

    // Contact partial
    contactSearch (query) {
        if (!query) {
            return [{ add: true }]
        } else {
            return this.$http.get('/contacts/search/' + encodeURIComponent(query)).then(result => {
                let data = result.data
                data.push({ add: true })

                return data
            })
        }
    }

    contactAddToItem (contact) {
        if (contact) {
            if (contact.add) {
                this.contactCreate()
                return
            }

            if (contact && contact.id) {
                this.yItem.get('contacts').set(contact.id.toString(), contact)
            }

            // Clear contact search suggest
            this.$scope.selectedOption = undefined
            this.contactSearchText = ''
        }
    }

    contactOpenBlade (id) {
        let contactState = this.$state.current.name
        if (this.$state.current.name.split('.').indexOf('contact') > -1) {
            this.$state.go(contactState, {
                contactId: id
            })
        } else {
            this.$state.go('.contact', {
                contactId: id
            })
        }
    }

    contactCreate () {
        this.$scope.selectedOption = undefined
        this.contactSearchText = ''
        this.Contact.save({}, (data) => {
            let nextState = this.$state.is('rundown.edit.contact') ? '.' : '.contact'
            // if (this.$state.is('rundown.edit.contact')) {
            //     this.$state.go('^');
            // }
            this.$state.go(nextState, {
                contactId: data.id,
                create: true
            })
        })
    }

    contactUpdate (ev, data) {
        if (data.hasOwnProperty('id')) {

            data = data.toJSON()
            delete data.modeltype

            this.yItem.get('contacts').set(data.id.toString(), data)
        }

    }

    contactDelete (ev, id) {
        ev.preventDefault()
        this.yItem.get('contacts').delete('' + id)
    }

    contactBlur () {
        setTimeout(() => {
            let input = angular.element(document.querySelector('md-autocomplete.contact-autocomplete input'))
            input.blur()
        }, 100)
    }

    // End contact partial

    goBackAction () {
        this.dontCheckState = true

        switch (this.$state.current.name) {
            case 'rundown.edit.contact':
            case 'rundown.drafts.edit.contact':
                this.$state.go('^.^')
                break
            default:
                this.$state.go('^')
                break
        }
    }

    close () {
        const { yItem, customFields } = this
        let fieldValues = yItem.get('field_values')
        let modelTypeId = yItem.get('model_type_id')

        let emptyRequiredFieldNames = []
        for (let fieldIndex in customFields[modelTypeId]) {
            if (customFields[modelTypeId].hasOwnProperty(fieldIndex)) {
                let field = customFields[modelTypeId][fieldIndex]
                if (field.options.required) {
                    const requiredField = fieldValues.get(field.name)
                    if (!requiredField || requiredField.toString() === '') {
                        emptyRequiredFieldNames.push(field.name)
                    }
                }
            }
        }

        if (emptyRequiredFieldNames.length > 0) {

            this.$mdDialog.show({

                controller: 'ConfirmDialogCtrl',
                templateUrl: 'warnUnsaved.ngTemplate',
                parent: angular.element(document.querySelector('#popupContainer')),
                clickOutsideToClose: true,
                multiple: true
            }).then(() => {
                this.widgets.saveWidgetsForTypeId('item-' + this.$state.params.itemId).then(() => {
                    this.goBackAction()
                })

            }, () => {
            })
        } else {

            this.widgets.saveWidgetsForTypeId('item-' + this.$state.params.itemId).then(() => {
                this.goBackAction()
            })
        }
    }

    showRevisions (ev) {
        this.$http.get('/revisions/items/' + this.$state.params.itemId).then(revisions => {
            this.$mdDialog.show({
                controller: 'RevisionDialogCtrl',
                templateUrl: 'revisionDialog.ngTemplate',
                parent: angular.element(document.querySelector('#popupContainer')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    revisions: revisions.data
                },
                multiple: true
            })
                .then(values => {
                    if (!this.yItem) {
                        console.log('NO Y')
                        return
                    }

                    this.updateYField('title', values.title)
                    this.pmComponent.content = values.details

                    this.updateModelType(values.model_type_id)
                    this.updateYField('recommended', values.recommended)
                    this.updateYField('external_id', values.external_id)
                    this.updateYField('duration', values.duration)
                    this.updateYField('static_start', values.static_start)

                    this.updateYField('static_start', values.static_start)

                    this.yItem.get('contacts').keys().forEach(contactId => {
                        if (values.contacts.indexOf(contactId) < 0) {
                            this.yItem.get('contacts').delete(contactId)
                        }
                    })
                    if (values.contacts.length > 0) {
                        let sharedContactIds = this.yItem.get('contacts').keys()
                        this.$http.get('contacts/ids/' + values.contacts)
                            .then(({ data }) => {
                                data.forEach(contact => {
                                    if (sharedContactIds.indexOf(contact.id) < 0) {
                                        this.yItem.get('contacts').set(contact.id.toString(), contact)
                                    }
                                })
                            })

                    }

                    this.yItem.get('tags').delete(0, this.yItem.get('tags').toArray().length)

                    if (values.tags.length > 0) {
                        let oldTags = this.yItem.get('tags').toArray()
                        values.tags.forEach(tag => {
                            if (oldTags.indexOf(tag) < 0) {
                                this.yItem.get('tags').push([tag])
                            }
                        })
                    }

                    let fieldValues = JSON.parse(values.field_values)

                    if (Object.keys(fieldValues).length > 0) {
                        const yFieldValues = this.yItem.get('field_values')
                        for (let key in fieldValues) {

                            if (yFieldValues.get(key)) {
                                yFieldValues.get(key).delete(0, yFieldValues.get(key).toString().length)

                            } else {
                                yFieldValues.set(key, Y.Text)
                            }

                            yFieldValues.get(key).insert(0, fieldValues[key])
                        }

                    }

                }).catch(() => {
            })

        })
    }

    updateYField (name, data = null) {
        if (this.DESTROYING) return
        console.log('updateYField ' + name + ' ' + data)
        let field = this.yItem.get(name),
            yText = field.toString(),
            mText = data != null ? data.toString() : ''

        if (mText != yText) {
            field.delete(0, yText.length)
            field.insert(0, mText)
        }
    }

    updateModelType (id) {

        let modelTypeObj = null
        this.itemModelTypes.forEach((modelType) => {
            if (id == modelType.id) {
                modelTypeObj = modelType
            }
        })

        if (!modelTypeObj) return

        this.yItem.set('model_type_id', id)
    }

    backToCampaign () {
        const campaignId = this.yItem.get('campaign_id')
        if (campaignId) {
            this.$state.go('campaign.update', {
                id: campaignId
            })
        }
    }

    backToItemPlannerCampaign () {
        const { yItem, $state } = this
        const campaignId = yItem.get('campaign_id')
        if (campaignId) {
            const start = moment(yItem.get('start').toString())
            $state.go('item-planner.update', {
                id: campaignId,
                date: start.format('YYYY-MM-DD')
            })
        }
    }
}

RundownEditCtrl.$inject = [
    'Contact',
    '$http',
    '$mdDialog',
    'masterStationInfo',
    'itemModelTypes',
    '$scope',
    '$state',
    'widgets',
    'yConnection',
    'yDraftConnections',
    '$rootScope',
    '$transitions'
]

module.exports = RundownEditCtrl
